import styled from 'styled-components';

export const StyledLineChartCard = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  .chart-card {
    padding: 25px 35px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    height: 100%;

    &-content {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 90%;
    }

    .chart-card-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      &-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .title {
          color: #2f2f35;
          font-family: Poppins, sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          margin-right: 8px;
        }

        .icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }
      }

      &-content {
        height: inherit;
        border-radius: 4px;
        padding: 5px 11px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #2f2f35;
        font-family: Poppins, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        background-color: ${(props) =>
          props.bgColor
            ? 'rgba(' + props.bgColor.r + ',' + props.bgColor.g + ',' + props.bgColor.b + ',0.15)'
            : 'white'};
        overflow: revert;
        max-lines: 1;
      }
    }
  }
`;
